import React from 'react';

interface VersionDisplayProps {
  className?: string;
}

const VersionDisplay: React.FC<VersionDisplayProps> = ({ className = '' }) => {
  const environment = process.env.REACT_APP_ENVIRONMENT || 'dev';
  const version = process.env.REACT_APP_VERSION || '1.0.0';
  const enableDebugMode = process.env.REACT_APP_ENABLE_DEBUG_MODE === 'true';

  // Only show environment indicator in non-production environments
  const showEnvironmentIndicator = environment !== 'prod';

  return (
    <div className={`version-display ${className}`}>
      <small className="text-muted">
        v{version}
        {showEnvironmentIndicator && (
          <>
            {' '}
            <span className={`badge ${getEnvironmentBadgeClass(environment)}`}>
              {environment.toUpperCase()}
            </span>
          </>
        )}
        {enableDebugMode && (
          <>
            {' '}
            <span className="badge bg-warning text-dark">
              <i className="fas fa-bug me-1"></i>
              DEBUG
            </span>
          </>
        )}
      </small>
    </div>
  );
};

const getEnvironmentBadgeClass = (environment: string): string => {
  switch (environment) {
    case 'dev':
      return 'bg-info';
    case 'staging':
      return 'bg-warning text-dark';
    case 'prod':
      return 'bg-success';
    default:
      return 'bg-secondary';
  }
};

export default VersionDisplay;
